import { faCheckSquare, faXmarkSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import ActivateUserFormModal from 'src/features/users/components/forms/ActivateUserFormModal';
import DeactivateUserFormModal from 'src/features/users/components/forms/DeactivateUserFormModal';
import UpdateUserFormModal from 'src/features/users/components/forms/UpdateUserFormModal';
import { userMessages } from 'src/features/users/utils/messages';
import { Membership, MEMBERSHIP_STATUS } from 'src/features/users/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellUserActions({ row }: CellContext<Membership, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                {row.original.status === MEMBERSHIP_STATUS.ACTIVE ? (
                    <Tooltip>
                        <DeactivateUserFormModal
                            selectedUser={row.original}
                            semantics={{ entryName: formatMessage(userMessages.user).toLowerCase() }}
                        >
                            <TooltipTrigger asChild>
                                <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                    <FontAwesomeIcon icon={faXmarkSquare} />
                                </Button>
                            </TooltipTrigger>
                        </DeactivateUserFormModal>
                        <TooltipContent>
                            <FormattedMessage {...userMessages.deactivateUser} />
                        </TooltipContent>
                    </Tooltip>
                ) : (
                    <Tooltip>
                        <ActivateUserFormModal
                            selectedUser={row.original}
                            semantics={{ entryName: formatMessage(userMessages.user).toLowerCase() }}
                        >
                            <TooltipTrigger asChild>
                                <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                    <FontAwesomeIcon icon={faCheckSquare} />
                                </Button>
                            </TooltipTrigger>
                        </ActivateUserFormModal>
                        <TooltipContent>
                            <FormattedMessage {...userMessages.activateUser} />
                        </TooltipContent>
                    </Tooltip>
                )}
                <Tooltip>
                    <UpdateUserFormModal
                        semantics={{ entryName: formatMessage(userMessages.user).toLowerCase() }}
                        selectedMembership={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateUserFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
